import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC, useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'

import FilterButton from '../Filters'
import { getLocations } from '@user/store/locations/api'
import { LocationFilters } from './LocationFilters'
import { LocationList } from './LocationList'
import { PageHeader, SettingsPage } from '@sales-center/components'
import {
  selectLocationFilters,
  selectLocationPageState,
  setLocationFilters,
  setLocationPage,
} from '@user/store/locations/slice'
import { updateLoadingState } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import Box from '@mui/material/Box'
import Pagination from '@mui/material/Pagination'

const getStyles = (theme: Theme) => ({
  listWrapper: {
    maxWidth: theme.breakpoints.values.lg,
  },
})

export const Locations: FC = () => {
  const dispatch = useAppDispatch()

  const { page, pages, count, loading } = useSelector(selectLocationPageState)

  const { filterSet, defaultFilters, orderByOptions } = useSelector(
    selectLocationFilters,
  )

  const setFilters = useCallback(
    (model) => dispatch(setLocationFilters(model)),
    [dispatch],
  )

  const onChangePage = useCallback(
    (_e: React.ChangeEvent<unknown>, newPage: number) =>
      dispatch(setLocationPage(newPage)),
    [dispatch],
  )

  useEffect(() => {
    dispatch(getLocations())
  }, [dispatch, page, filterSet])

  useEffect(() => {
    dispatch(updateLoadingState(loading ? 'visible' : 'hidden'))
  }, [dispatch, loading])

  const PaginationComponent = () =>
    pages > 1 ? (
      <Pagination
        page={page}
        count={pages}
        onChange={onChangePage}
        color="primary"
        style={{ marginLeft: 'auto' }}
      />
    ) : null
  const styles = getStyles(useTheme())
  return (
    <SettingsPage
      title="Locations"
      padding="20px 20px 20px 40px"
      headContent={
        <PageHeader>
          {count} {count == 1 ? 'Location' : 'Locations'}
          <Box marginLeft="auto">
            <FilterButton
              initialValues={filterSet}
              defaultValues={defaultFilters}
              clearedValues={defaultFilters}
              orderOptions={orderByOptions}
              applyCallback={setFilters}
              filterComponent={LocationFilters}
            />
          </Box>
        </PageHeader>
      }
    >
      <Box sx={styles.listWrapper}>
        <Box display="flex" mb={1}>
          <PaginationComponent />
        </Box>

        <LocationList />
        <Box display="flex" mt={1}>
          <PaginationComponent />
        </Box>
      </Box>
    </SettingsPage>
  )
}
